
import { requests } from '../utils/urls';
import axios from '../utils/axios';
export const GetOtp = async ({ ...data }) => {
  const res = await axios({
    method: 'POST',
    url: requests.auth.getOtp,
    data,
  });
  return res;
};
export const SendOtp = async ({ ...data }) => {
  const res = await axios({
    method: 'POST',
    url: requests.auth.loginOrRegister,
    data,
  });
  return res;
};
export const LoginUserPass = async ({ ...data }) => {
  const res = await axios({
    method: 'POST',
    url: requests.auth.loginUserPass,
    data,
  });
  return res;
};
export const ResetPass = async ({ ...data }) => {
  const res = await axios({
    method: 'PATCH',
    url: requests.auth.resetPass,
    data,
  });
  return res;
};
export const ForgetsPassword = async ({ ...data }) => {
  const res = await axios({
    method: 'PATCH',
    url: requests.auth.forgetPassword,
    data,
  });
  return res;
};
export const CheckOtp = async ({ phoneNumber, code }) => {
  const res = await axios({
    method: 'GET',
    url: requests.auth.checkOtp + phoneNumber + `/` + code,
  });
  return res;
};
export const Logout = async () => {
  const res = await axios({
    method: 'POST',
    url: requests.auth.logout,
  });
  return res;
};
export const GetUser = async () => {
  const res = await axios({
    method: 'GET',
    url: requests.auth.getUser,
  });
  return res;
};
export const ViewProfile = async () => {
  try {
    const res = await axios({
      method: 'GET',
      url: requests.user.viewProfile,
    });
    return res;
  } catch (e) {
    return e.response;
  }
};
// export const LoginUserPass = async (values) => {
//   try {
//       const response = await axios.post(REQUESTS.AUTH.LoginUserPass, values);
//       return response;
//   } catch (e) {
//       return e.response;
//   }
// };
export const EditProfile = async ({ first_name, last_name, email, gender, birth_date, avatar }) => {
  const frmData = new FormData();
  frmData.append('first_name', first_name);
  frmData.append('last_name', last_name);
  frmData.append('email', email);
  frmData.append('gender', gender);
  frmData.append('birth_date', birth_date);
  if (avatar) {
    frmData.append('avatar', avatar);
  }
  try {
    const res = await axios({
      headers: {
        'Content-Type': '"multipart/form-data","application/json"',
      },
      method: 'POST',
      url: requests.user.editProfile,
      data: frmData,
    });
    return res;
  } catch (e) {
    return e.response;
  }
};
export const ADD_BANK_ACCOUNT = async ({ ...data }) => {
  const res = await axios({
    method: 'POST',
    url: requests.user.addBankAccount,
    data,
  });
  return res;
};
export const GET_BANK_ACCOUNT = async () => {
  try {
    const res = await axios({
      method: 'GET',
      url: requests.user.bankAccount,
    });
    return res;
  } catch (e) {
    return e.response;
  }
};
export const DEL_BANK_ACCOUNT = async (id) => {
  const res = await axios({
    method: 'DELETE',
    url: requests.user.deleteBankAccount + id,
  });
  return res;
};
export const GET_SHOPS = async () => {
  const res = await axios({
    method: 'GET',
    url: requests.management.shop.getAll,
  });
  return res;
};
export const VIEW_SHOP = async ({ id }) => {
  const res = await axios({
    method: 'GET',
    url: requests.management.shop.getById + `/${id}`,
  });
  return res;
};
export const ADD_SHOP_CATEGORIES = async ({ name, position, priority, media }) => {
  const frmData = new FormData();
  frmData.append('name', name);
  frmData.append('position', position);
  frmData.append('priority', priority);
  if (media) {
    frmData.append('media', media);
  }
  const res = await axios({
    headers: {
      'Content-Type': '"multipart/form-data","application/json"',
    },
    method: 'POST',
    url: requests.management.shopCategory.create,
    data: frmData,
  });
  return res;
};
export const GET_PAYMENT_METHODS = async () => {
  const res = await axios({
    method: 'GET',
    url: requests.management.shopSettings.paymentMethods,
  });
  return res;
};
export const ADD_SHOP = async ({
  name,
  logo,
  header,
  wage,
  has_in_person,
  price_per_km,
  has_courier,
  descriptions,
  categories,
  meal_tags,
  payment_methods,
  call_numbers,
  full_address,
  // postal_code,
  latitude,
  longitude,
  uuid,
  is_active,
  price,
  predefine_geofences,
}) => {
  const frmData = new FormData();
  //  const categories=[]
  frmData.append('name', name);
  frmData.append('wage', wage);
  frmData.append('has_in_person', has_in_person);
  frmData.append('has_courier', has_courier);
  frmData.append('price_per_km', price_per_km);
  frmData.append('descriptions', descriptions);
  frmData.append('address[full_address]', full_address);
  // frmData.append('address[postal_code]', postal_code);
  frmData.append('address[latitude]', latitude);
  frmData.append('address[longitude]', longitude);
  for (let i = 0; i < uuid.length; i++) {
    frmData.append(`predefine_geofences[${i}][uuid]`, uuid[i]);
    frmData.append(`predefine_geofences[${i}][is_active]`, is_active[i]);
    frmData.append(`predefine_geofences[${i}][price]`, price[i]);
  }
  for (let i = 0; i < categories.length; i++) {
    frmData.append('categories[]', categories[i]);
  }
  for (let i = 0; i < meal_tags.length; i++) {
    frmData.append('meal_tags[]', meal_tags[i]);
  }
  for (let i = 0; i < payment_methods.length; i++) {
    frmData.append(`payment_methods[${i}]`, payment_methods[i]);
  }
  for (let i = 0; i < call_numbers.length; i++) {
    frmData.append(`call_numbers[${i}][value]`, call_numbers[i]);
  }
  if (logo) {
    frmData.append('logo', logo);
  }
  if (header) {
    frmData.append('header', header);
  }
  const res = await axios({
    headers: {
      'Content-Type': '"multipart/form-data","application/json"',
    },
    method: 'POST',
    url: requests.management.shop.create,
    data: frmData,
  });
  return res;
};
export const EDIT_SHOP = async ({
  name,
  id,
  logo,
  header,
  wage,
  has_in_person,
  price_per_km,
  has_courier,
  is_active_express_courier,
  descriptions,
  categories,
  meal_tags,
  payment_methods,
  status,
  call_numbers,
  full_address,
  postal_code,
  latitude,
  longitude,
  uuid,
  price,
  is_active,
  predefine_geofences,
}) => {
  const urlencoded = new URLSearchParams();
  //  const categories=[]
  urlencoded.append('name', name);
  urlencoded.append('has_in_person', has_in_person);
  urlencoded.append('has_courier', has_courier);
  urlencoded.append('status', status);
  urlencoded.append('price_per_km', price_per_km);
  urlencoded.append('descriptions', descriptions);
  // frmData.append('address[full_address]', full_address);
  // frmData.append('address[postal_code]', postal_code);
  // frmData.append('address[latitude]', latitude);
  // frmData.append('address[longitude]', longitude);
  // frmData.append('predefine_geofences[0][uuid]', uuid);
  // frmData.append('predefine_geofences[0][price]', price);
  // frmData.append('predefine_geofences[][is_active]', is_active);
  // for (let i = 0; i < predefine_geofences.length; i++) {
  //   frmData.append('predefine_geofences[][uuid]', predefine_geofences[i]);
  //   frmData.append('predefine_geofences[][price]', predefine_geofences[i]);
  //   frmData.append('predefine_geofences[][is_active]', predefine_geofences[i]);
  // }
  // for (let i = 0; i < categories.length; i++) {
  //   frmData.append('categories[]', categories[i]);
  // }
  // for (let i = 0; i < meal_tags.length; i++) {
  //   frmData.append('meal_tags[]', meal_tags[i]);
  // }
  for (let i = 0; i < payment_methods.length; i++) {
    urlencoded.append(`payment_methods[${i}]`, payment_methods[i]);
  }
  // for (let i = 0; i < call_numbers.length; i++) {
  //   frmData.append('call_numbers[][value]', call_numbers[i]);
  // }
  // if (logo) {
  //   frmData.append('logo', logo);
  // }
  // if (header) {
  //   frmData.append('header', header);
  // }
  const res = await axios({
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    method: 'PATCH',
    url: requests.management.shop.edit + `/${id}`,
    data: urlencoded,
  });
  return res;
};
export const EDIT_SHOP_LOGO = async ({ logo, id }) => {
  const frmData = new FormData();
  if (logo) {
    frmData.append('logo', logo);
  }
  const res = await axios({
    headers: {
      'Content-Type': '"multipart/form-data","application/json"',
    },
    method: 'POST',
    url: requests.management.shopSettings.editLogo + `${id}/logo`,
    data: frmData,
    params: { _method: 'PATCH' },
  });
  return res;
};
export const EDIT_SHOP_HEADER = async ({ header, id }) => {
  const frmData = new FormData();
  //  const categories=[]
  // frmData.append('name', name);
  if (header) {
    frmData.append('header', header);
  }
  const res = await axios({
    headers: {
      'Content-Type': '"multipart/form-data","application/json"',
    },
    method: 'POST',
    url: requests.management.shopSettings.editHeader + `${id}/header`,
    data: frmData,
    params: { _method: 'PATCH' },
  });
  return res;
};
export const EDIT_SHOP_CATEGORIES = async ({ name, position, priority, media, id }) => {
  const frmData = new FormData();
  frmData.append('name', name);
  frmData.append('position', position);
  frmData.append('priority', priority);
  frmData.append('id', id);
  if (media) {
    frmData.append('media', media);
  }
  const res = await axios({
    headers: {
      'Content-Type': '"multipart/form-data","application/json"',
    },
    method: 'POST',
    url: requests.management.shopCategory.edit + '/' + id,
    // + "?_method=PATCH",
    data: frmData,
    params: { _method: 'PATCH' },
  });
  return res;
};
export const DELETE_SHOP_CATEGORIES = async ({ id }) => {
  const res = await axios({
    method: 'DELETE',
    url: requests.management.shopCategory.delete + '/' + id,
  });
  return res;
};
export const GET_GEOFANCE = async () => {
  const res = await axios({
    method: 'GET',
    url: requests.management.geofence.getAll,
  });
  return res;
};
export const SHOW_GEOFANCE = async ({ id }) => {
  const res = await axios({
    method: 'GET',
    url: requests.management.geofence.getById + `/` + id,
  });
  return res;
};
export const ADD_GEOFANCE = async ({ ...data }) => {
  const res = await axios({
    method: 'POST',
    url: requests.management.geofence.create,
    data,
  });
  return res;
};
export const EDIT_GEOFANCE = async ({ id, ...data }) => {
  const res = await axios({
    method: 'PATCH',
    url: requests.management.geofence.edit + '/' + id,
    data,
  });
  return res;
};
export const editTime = async ({ id, wId, ...data }) => {
  try {
  const response = await axios({
    method: 'PATCH',
    url: requests.management.shop.getShop + '/' + id + '/working-hour/' + wId,
    data,
  });
  return response;
}catch (e) {
  return e.response;
}
};
// export const DELETE_TIME = async ({ id, wId }) => {
//   const res = await axios({
//     method: 'DELETE',
//     url: REQUESTS.MANAGEMENT.SHOP.GET_SHOP + '/' + id + '/working-hour/' + wId,
//   });
//   return res;
// };
export const deleteTime = async ({ id, wId }) => {
  try {
    const response = await axios({
      method: 'DELETE',
      url: requests.management.shop.getShop + '/' + id + '/working-hour/' + wId,
    });
  
    return response;
  }catch (e) {
      return e.response;
  }
};
export const CheckISActive = async ({ id, ...data }) => {
  const res = await axios({

    method: 'PATCH',
    url: requests.management.geofence.isActive + id + `/update-active-status`,
    data,
  });

  return res;
};

export const CheckShopGeofanceISActive = async ({ shopId, GeoId, ...data }) => {
  const res = await axios({
    method: 'PATCH',
    url: requests.management.shop.EDITCATEGORY + shopId + `/geofence/` + GeoId,
    data,
  });

  return res;
};

export const SHOW_SHOP_GEOFANCE = async ({ shopId, geoId }) => {
  const res = await axios({
    method: 'GET',
    url: requests.management.shop.getShop +  `/${shopId}` + `/geofence/` + geoId,
  });

  return res;
};

export const EDIT_SHOP_GEOFANCE = async ({ shopId, geoId, ...data }) => {
  const res = await axios({
    method: 'PATCH',
    url: requests.management.shop.getShop +  `/${shopId}` + `/geofence/` + geoId,
    data,
  });

  return res;
};

export const DELETE_SHOP_GEOFANCE = async ({ shopId, geoId, ...data }) => {
  const res = await axios({
    method: 'DELETE',
    url: requests.management.shop.getShop +  `/${shopId}` + `/geofence/` + geoId,
    data,
  });

  return res;
};
export const CREATE_SHOP_GEOFANCE = async ({ shopId, ...data }) => {
  const res = await axios({
    method: 'POST',
    url: requests.management.shop.getShop + `/${shopId}` + `/geofence`,
    data,
  });

  return res;
};
export const DELETE_GEOFANCE = async ({ id }) => {
  const res = await axios({
    method: 'DELETE',
    url: requests.management.GEOFANCE.GEOFANCE + '/' + id,
  });

  return res;
};

export const GET_CALNUMBER = async () => {
  const res = await axios({
    method: 'GET',
    url: requests.management.CALNUMBER.GET,
  });

  return res;
};

export const SHOW_MAP_ADDRESS = async ({ ...data }) => {
  const res = await axios({
    method: 'POST',
    url: requests.management.MAPS.GET,
    data,
  });

  return res;
};
export const Edit_MAP_ADDRESS = async ({ ...data }) => {
  const res = await axios({
    method: 'PATCH',
    url: requests.management.MAPS.GET,
    data,
  });

  return res;
};